import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toggleHeaderMenuExpanded } from '../../settings/actions/application-actions';

class DefaultHeader extends Component {
	render() {
		const { toggleHeaderMenuExpanded } = this.props;

		return (
			<header className="header-flex-container header-default">
				<div className="header-flex-left">
					<div className="hamburger-menu-container" onClick={toggleHeaderMenuExpanded}>
						<div className="hamburger-menu" />
						<span>Menu</span>
					</div>
					<div className="header-item logo" onClick={this.props.navigateHome}>
						&nbsp;
						<span className="hidden">iMemories&reg;</span>
					</div>
				</div>
				<div className="header-flex-right">
					<div className="header-flex-spacer" />
				</div>
			</header>
		);
	}
}

DefaultHeader.propTypes = {
	toggleHeaderMenuExpanded: PropTypes.func,
	navigateHome: PropTypes.func
};

const mapDispatchToProps = dispatch => {
	return {
		toggleHeaderMenuExpanded: (evt) => {
			dispatch(toggleHeaderMenuExpanded());
			if(evt) evt.stopPropagation();
		}
	};
};

export default connect(null, mapDispatchToProps)(DefaultHeader);



// WEBPACK FOOTER //
// ./src/header/components/default-header.jsx